import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class TrialSignupValidationService {
    constructor(ajax, urls) {
        this.ajax = ajax;
        this.urls = urls;
        this.phoneStripRegex = /[^\d+x]+/;
        this.passwordComplexityRegex = /(?=.*[a-z])(?=.*[A-Z])/;
    }
    validatePhone(phoneNumber) {
        if (!phoneNumber) {
            return null;
        }
        const nonCharPhone = phoneNumber.replace(this.phoneStripRegex, '');
        let phoneError = null;
        if (!nonCharPhone || nonCharPhone.length < 4 || nonCharPhone.length > 11 + 5 + 4) {
            // Length of phone numbers comes from here:
            // http://msdn.microsoft.com/en-us/goglobal/bb688129.aspx
            // 11 + 5 + 4 is 'max phone number length' + 'max extension length' +
            // 'max country code length'
            phoneError = 'Please enter a valid phone number.';
        }
        return phoneError;
    }
    validateEmail(emailVal) {
        return this.ajax
            .postFormEncodedDataObserveResponse(this.urls.STORE.VALIDATE_FREE_TRIAL_EMAIL, { email: emailVal })
            .pipe(map((response) => (response.ok ? null : response.body)), catchError((err) => of(err.error)));
    }
    validatePassword(passwordVal) {
        if (!passwordVal) {
            return null;
        }
        const isValid = this.passwordComplexityRegex.test(passwordVal);
        let passwordError = null;
        if (!isValid) {
            passwordError =
                'Password must contain at least 1 lowercase letter, 1 upper case letter, and 1 special character ' +
                    '(!,@,#,$,%%,&).';
        }
        return passwordError;
    }
}
TrialSignupValidationService.ɵfac = function TrialSignupValidationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TrialSignupValidationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
TrialSignupValidationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TrialSignupValidationService, factory: TrialSignupValidationService.ɵfac, providedIn: 'root' });
